export enum ReadingSpeedEnum {
    X_SLOW = 'X_SLOW',
    SLOW = 'SLOW',
    MEDIUM = 'MEDIUM',
    FAST = 'FAST',
    X_FAST = 'X_FAST'
}
